import * as React from 'react';
import { GdsService_OrderAdditionalServiceGdsServiceVip_Fragment } from '@websky/graphql';
import { PassengersById, SegmentsById, State } from '../TransferService/model';
import ServiceSummaryOption from '../../../ServiceSummary/components/ServiceSummaryOption';
import { useTransferServiceSummary } from './model';

export interface Props {
	service: GdsService_OrderAdditionalServiceGdsServiceVip_Fragment;
	segments: SegmentsById;
	passengers: PassengersById;
	servicesState: State['services'];
}

const TransferServiceSummary: React.FC<Props> = ({ servicesState, segments, passengers, service }) => {
	const model = useTransferServiceSummary(service, segments, passengers, servicesState);

	return (
		<>
			{model.serviceSummaryOptions.map(summaryGroup => {
				return <ServiceSummaryOption key={summaryGroup.header} groupOption={summaryGroup} />;
			})}
		</>
	);
};

export default TransferServiceSummary;
